import { useQuery } from "@tanstack/react-query";
import { TechnologyCanonicalDictionaryModel, technologyCanonicalDictionaryService } from "../../services/dictionaries";

export const useTechnologyCanonicalsDictionary = () => {
    return useQuery({
        queryKey: ["technology-canonicals", "dictionary"],
        queryFn: (): Promise<TechnologyCanonicalDictionaryModel[]> =>
            technologyCanonicalDictionaryService.getTechnologyCanonicals(),
        staleTime: 1000 * 60 * 15, // 15 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
    });
};
